import { getAxiosInstance } from '../client';
/** Mutation functions for feature toggles */
export const featureToggleMutations = {
    /** POST /feature-toggle/office-location/:officeLocationId */
    save: (officeLocationId, dto) => getAxiosInstance()
        .post(`/feature-toggle/office-location/${officeLocationId}`, dto)
        .then((r) => r.data),
};
//# sourceMappingURL=feature-toggle.mutations.js.map